export class ChangePasswordRequestModel {
    public currentPassword: string;
    public newPassword: string;
    public confirmPassword: string;
}